import { render } from "./MyPosts.vue?vue&type=template&id=ac81f244&scoped=true"
import script from "./MyPosts.vue?vue&type=script&lang=js"
export * from "./MyPosts.vue?vue&type=script&lang=js"

import "./MyPosts.vue?vue&type=style&index=0&id=ac81f244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac81f244"]])

export default __exports__